import type { Schema } from '../../../Entities/Schema.entity';
import { createSchema } from '../../../Utils/CreateSchema';

export const registrationSuccessSchema: Schema = {
  ...createSchema({
    version: '1-0-0',
    description: 'Tracks when a user completes the registration process',
    name: 'registration_success',
    properties: {},
  }),
};
